import { Navigate, Route, Routes } from 'react-router-dom';
import {
  BOOKING_LOGIN_PATH,
  BOOKING_ACTIVATION_PATH,
  BOOKING_FORGOT_PASSWORD_PATH,
  BOOKING_EMAIL_CHANGE_PATH,
  BOOKING_HOME_PATH,
  BOOKING_DETAIL_PATH,
  BOOKING_REGISTRATION_PATH,
  BOOKING_CONTACT_PATH,
  BOOKING_THANKYOU_PATH,
  BOOKING_SLUG_CONTACT_PATH,
  BOOKING_SLUG_THANKYOU_PATH,
  BOOKING_SLUG_PAYMENT_RETURN_PATH,
  BOOKING_SLUG_CREDIT_PURCHASE_PATH,
  BOOKING_SLUG_CREDIT_PURCHASE_RETURN_PATH,
  BOOKING_ACCOUNT_PATH,
  BOOKING_ACCOUNT_BOOKINGS_PATH,
  BOOKING_ACCOUNT_BOOKING_DETAIL_PATH,
  BOOKING_ACCOUNT_INVOICES_PATH,
  BOOKING_ACCOUNT_INVOICE_DETAIL_PATH,
  BOOKING_ACCOUNT_CREDITS_PATH,
  BOOKING_ACCOUNT_CREDIT_PURCHASES_PATH,
  BOOKING_ACCOUNT_CREDIT_PURCHASE_DETAIL_PATH,
  BOOKING_ACCOUNT_PROFILE_PATH,
  BOOKING_ACCOUNT_PASSWORD_PATH,
  BOOKING_GUEST_MANAGE_PATH,
  BOOKING_GUEST_MANAGE_STORED_PATH,
} from 'routes/paths';
import BookingLogin from 'pages/booking/BookingLogin';
import BookingHome from 'pages/booking/BookingHome';
import BookingDetail from 'pages/booking/BookingDetail';
import BookingContact from 'pages/booking/BookingContact';
import BookingThankyou from 'pages/booking/BookingThankyou';
import BookingGuard from 'pages/booking/BookingGuard';
import BookingPaymentReturn from 'pages/booking/BookingPaymentReturn';
import BookingNotFound from 'pages/booking/BookingNotFound';
import AccountBookings from 'pages/booking/account/AccountBookings';
import AccountBookingDetail from 'pages/booking/account/AccountBookingDetail';
import AccountInvoices from 'pages/booking/account/AccountInvoices';
import AccountInvoicePreview from 'pages/booking/account/AccountInvoicePreview';
import AccountCredits from 'pages/booking/account/AccountCredits';
import GuestBookingManagement from 'pages/booking/GuestBookingManagement';
import CreditPurchaseCheckout from 'pages/booking/credits/CreditPurchaseCheckout';
import CreditPurchaseReturn from 'pages/booking/credits/CreditPurchaseReturn';
import AccountCreditPurchases from 'pages/booking/account/AccountCreditPurchases';
import AccountCreditPurchaseDetail from 'pages/booking/account/AccountCreditPurchaseDetail';
import BookingRegistration from 'pages/booking/BookingRegistration';
import BookingActivation from 'pages/booking/BookingActivation';
import BookingForgotPassword from 'pages/booking/BookingForgotPassword';
import BookingEmailChange from 'pages/booking/BookingEmailChange';
import AccountProfile from 'pages/booking/account/AccountProfile';
import AccountPassword from 'pages/booking/account/AccountPassword';

/**
 * All routes in the app must be registered here.
 */
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={BOOKING_HOME_PATH.original} replace />} />
      <Route path={BOOKING_LOGIN_PATH.original} element={<BookingLogin />} />
      <Route path={BOOKING_ACTIVATION_PATH.original} element={<BookingActivation />} />
      <Route path={BOOKING_FORGOT_PASSWORD_PATH.original} element={<BookingForgotPassword />} />
      <Route path={BOOKING_EMAIL_CHANGE_PATH.original} element={<BookingEmailChange />} />
      <Route path={BOOKING_REGISTRATION_PATH.original} element={<BookingRegistration />} />
      <Route
        path={BOOKING_HOME_PATH.original}
        element={
          <BookingGuard>
            <BookingHome />
          </BookingGuard>
        }
      />
      <Route path={BOOKING_DETAIL_PATH.original} element={<BookingDetail />} />
      <Route path={BOOKING_SLUG_CONTACT_PATH.original} element={<BookingContact />} />
      <Route path={BOOKING_SLUG_THANKYOU_PATH.original} element={<BookingThankyou />} />
      <Route path={BOOKING_SLUG_PAYMENT_RETURN_PATH.original} element={<BookingPaymentReturn />} />
      <Route
        path={BOOKING_SLUG_CREDIT_PURCHASE_PATH.original}
        element={
          <BookingGuard>
            <CreditPurchaseCheckout />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_SLUG_CREDIT_PURCHASE_RETURN_PATH.original}
        element={
          <BookingGuard>
            <CreditPurchaseReturn />
          </BookingGuard>
        }
      />
      <Route path={BOOKING_GUEST_MANAGE_PATH.original} element={<GuestBookingManagement />} />
      <Route path={BOOKING_GUEST_MANAGE_STORED_PATH.original} element={<GuestBookingManagement />} />
      <Route
        path={BOOKING_ACCOUNT_PATH.original}
        element={<Navigate to={BOOKING_ACCOUNT_BOOKINGS_PATH.original} replace />}
      />
      <Route
        path={BOOKING_ACCOUNT_BOOKINGS_PATH.original}
        element={
          <BookingGuard>
            <AccountBookings />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_ACCOUNT_BOOKING_DETAIL_PATH.original}
        element={
          <BookingGuard>
            <AccountBookingDetail />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_ACCOUNT_INVOICES_PATH.original}
        element={
          <BookingGuard>
            <AccountInvoices />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_ACCOUNT_INVOICE_DETAIL_PATH.original}
        element={
          <BookingGuard>
            <AccountInvoicePreview />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_ACCOUNT_CREDITS_PATH.original}
        element={
          <BookingGuard>
            <AccountCredits />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_ACCOUNT_CREDIT_PURCHASES_PATH.original}
        element={
          <BookingGuard>
            <AccountCreditPurchases />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_ACCOUNT_PROFILE_PATH.original}
        element={
          <BookingGuard>
            <AccountProfile />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_ACCOUNT_PASSWORD_PATH.original}
        element={
          <BookingGuard>
            <AccountPassword />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_ACCOUNT_CREDIT_PURCHASE_DETAIL_PATH.original}
        element={
          <BookingGuard>
            <AccountCreditPurchaseDetail />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_CONTACT_PATH.original}
        element={
          <BookingGuard>
            <BookingContact />
          </BookingGuard>
        }
      />
      <Route
        path={BOOKING_THANKYOU_PATH.original}
        element={
          <BookingGuard>
            <BookingThankyou />
          </BookingGuard>
        }
      />
      <Route path="*" element={<BookingNotFound />} />
    </Routes>
  );
}
